import * as i0 from '@angular/core';
import { input, computed, Component } from '@angular/core';
import { COMPONENT_STATE, GhostStateFragmentDirective } from '@futura/futura-ui/ghost';
import { getIconInfo } from '@futura/futura-ui/core';
import { TooltipDirective } from '@futura/futura-ui/tooltip';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
const _c0 = ["*"];
const _c1 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19) => ({
  "fut-chip-sm": a0,
  "fut-chip-lg": a1,
  "fut-chip-white": a2,
  "fut-chip-gray-200": a3,
  "fut-chip-green-A700": a4,
  "fut-chip-green-A100": a5,
  "fut-chip-accent-200": a6,
  "fut-chip-red-400": a7,
  "fut-chip-red-100": a8,
  "fut-chip-red-100-danger": a9,
  "fut-chip-secondary-100": a10,
  "fut-chip-secondary-200": a11,
  "fut-chip-secondary-300": a12,
  "fut-chip-secondary-400": a13,
  "fut-chip-secondary-700": a14,
  "fut-chip-secondary-800": a15,
  "fut-chip-secondary-900": a16,
  "fut-chip-excellent": a17,
  "fut-chip-perfect": a18,
  "d-flex align-items-center fut-gap-4": a19
});
function ChipComponent_ng_container_0_div_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const icon_r1 = ctx;
    i0.ɵɵproperty("fontSet", icon_r1.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(icon_r1.icon);
  }
}
function ChipComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵprojection(2);
    i0.ɵɵtemplate(3, ChipComponent_ng_container_0_div_1_Conditional_3_Template, 2, 2, "mat-icon", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_7_0;
    const translate_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("futTooltip", translate_r2(ctx_r2.tooltipContent()))("hideTooltip", !ctx_r2.tooltipContent())("ngClass", i0.ɵɵpureFunctionV(5, _c1, [ctx_r2.size() === "sm", ctx_r2.size() === "lg", ctx_r2.type() === "white", ctx_r2.type() === "gray-200", ctx_r2.type() === "green-A700", ctx_r2.type() === "green-A100", ctx_r2.type() === "accent-200", ctx_r2.type() === "red-400", ctx_r2.type() === "red-100", ctx_r2.type() === "red-100-danger", ctx_r2.type() === "secondary-100", ctx_r2.type() === "secondary-200", ctx_r2.type() === "secondary-300", ctx_r2.type() === "secondary-400", ctx_r2.type() === "secondary-700", ctx_r2.type() === "secondary-800", ctx_r2.type() === "secondary-900", ctx_r2.type() === "excellent", ctx_r2.type() === "perfect", !!ctx_r2.iconInfo()]));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", translate_r2(ctx_r2.chipLabel()), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_7_0 = ctx_r2.icon()) ? 3 : -1, tmp_7_0);
  }
}
function ChipComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ChipComponent_ng_container_0_div_1_Template, 4, 26, "div", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("futGhostStateFragment", ctx_r2.state())("futGhostStateFragmentText", "loading");
  }
}
let ChipComponent = /*#__PURE__*/(() => {
  class ChipComponent {
    constructor() {
      this.state = input(COMPONENT_STATE.NONE);
      this.size = input('md');
      this.type = input('gray-200');
      this.chipLabel = input('');
      this.tooltipContent = input('');
      this.iconInfo = input();
      this.icon = computed(() => {
        const iconInfo = this.iconInfo();
        if (!iconInfo) {
          return null;
        }
        if (typeof iconInfo !== 'string' && !iconInfo.icon) {
          return null;
        }
        return getIconInfo(iconInfo);
      });
    }
    static {
      this.ɵfac = function ChipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ChipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ChipComponent,
        selectors: [["fut-chip"]],
        inputs: {
          state: [1, "state"],
          size: [1, "size"],
          type: [1, "type"],
          chipLabel: [1, "chipLabel"],
          tooltipContent: [1, "tooltipContent"],
          iconInfo: [1, "iconInfo"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        consts: [[4, "transloco"], ["class", "fut-chip nowrap", 3, "futTooltip", "hideTooltip", "ngClass", 4, "futGhostStateFragment", "futGhostStateFragmentText"], [1, "fut-chip", "nowrap", 3, "futTooltip", "hideTooltip", "ngClass"], [3, "fontSet"]],
        template: function ChipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ChipComponent_ng_container_0_Template, 2, 2, "ng-container", 0);
          }
        },
        dependencies: [GhostStateFragmentDirective, TooltipDirective, NgClass, MatIcon, TranslocoDirective]
      });
    }
  }
  return ChipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ChipComponent };
